import React from 'react';
import { SquareStack } from 'lucide-react';
import './style.css';

const ExploreChangesButton = ({ 
    timelineLength, 
    type, // 'datapoint' or 'project'
    onClick 
}) => {
    const isFirstChange = timelineLength <= 1;

    return (
        <button
            onClick={onClick}
            className={`explore-history-btn ${isFirstChange ? 'first-change' : 'past-changes box-shadow-light'}`}
        >
            {isFirstChange ? (
                `First Change to This ${type === 'datapoint' ? 'Datapoint' : 'Project'}`
            ) : (
                <>
                    <SquareStack className="clock-icon" />
                    {`Explore ${type === 'datapoint' ? 'Datapoint' : 'Project'} Change History`}
                </>
            )}
        </button>
    );
};

export default ExploreChangesButton;
